import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { message } from "antd"; // optional, if you're using Ant Design
import AxiosInstance from "../../AxiosInstance";

export default function LoanProcess() {
  const navigate = useNavigate();

  useEffect(() => {
    const processLoanStep = async () => {
      // Extract the `res` param from the URL
      const urlParams = new URLSearchParams(window.location.search);
      const resParam = urlParams.get("res");

      if (!resParam) {
        message.error("Invalid request. Missing response token.");
        navigate("/phDashboard");
        return;
      }

      // Prepare payload
      const payload = { res: resParam };

      try {
        // Send API call
        const resp = await AxiosInstance().post(
          "/policy/loan/bajaj/kyc",
          payload
        );
        console.log("API Response:", resp);

        message.info("process completed, redirecting to dashboard.");
        navigate("/phDashboard");
      } catch (error) {
        console.error("Loan Process Error:", error);
        message.error("Something went wrong, please try again later.");
        navigate("/phDashboard");
      }
    };

    processLoanStep();
  }, [navigate]);

  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        fontSize: "1.1rem",
        fontWeight: "500",
      }}
    >
      <div>⏳ Processing your loan application...</div>
      <small className="text-muted">
        Please do not refresh or close this tab.
      </small>
    </div>
  );
}
